import { InfoCircleOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  getLabel,
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { useForm } from "antd/es/form/Form";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { BUSINESS_TYPE, RFQStatus } from "../../util/Constant";
import { Option } from "antd/es/mentions";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import Upload from "../../components/Upload";
import {
  isBuyer,
  isEnquiryPublished,
  isExporter,
  isManufacturerCumExporter,
  showAlert,
} from "../../util/helper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { MY_EXIM_API_RFQ } from "../../appRedux/services/requestQuotationsNetwork";
import moment from "moment";
import { labelComponent } from "../../util/UtilComponents";
import { startCase } from "lodash";
import { LoadingOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const shipmentTypes = [
  { label: "FCL (Full Container Load)", value: "fcl" },
  { label: "LCL (Less Container Load)", value: "lcl" },
];

const shipmentModes = [
  { label: "Sea", value: "sea" },
  { label: "Air", value: "air" },
];

const PostChaQuotationsDetails = () => {
  const { id } = useParams();
  const { loading } = useSelector(({ common }) => common);
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hasCloneParam = path.includes("clone");
  let isEdit = !hasCloneParam && isValidElement(id);
  const [form] = useForm();
  const authUser = useSelector(({ auth }) => auth.userData);
  const [selectedSourceCountry, setSelectedSourceCountry] = useState(
    isBuyer(authUser) ||
      isExporter(authUser) ||
      isManufacturerCumExporter(authUser)
      ? "India"
      : null
  );
  const [selectedDestinationCountry, setSelectedDestinationCountry] =
    useState(null);
  const [fileList, setFileList] = useState([{ src: "" }]);
  let isEditDisabled = false;
  const countries = useSelector(({ common }) => common.countries);
  const ports = useSelector(({ common }) => common.ports);
  const [sourcePortsData, setSourcePortsData] = useState(null);
  const [destinationPortsData, setDestinationPortsData] = useState([]);
  console.log("destinationPortsData", destinationPortsData)
  const { isMobile } = useGetBreakpoints();
  const [RFQFormStatus, setRFQFormStatus] = useState(null);
  const dispatch = useDispatch();
  const [filteredHsCodeData, setFilteredHsCodeData] = useState(null);
  const [filteredProductCategoryData, setFilteredProductCategoryData] = useState(null);
  const [hsCodeId, setHsCodeId] = useState(null);
  const [hsCodeData, setHsCodeData] = useState(null);
  const productList = useSelector((state) => state.myProducts.productsList);
  const categoryList = useSelector((state) => state.myProducts.categoryList);
  const [targetedBusinessType, setTargetedBusinessType] = useState(null);
  const [userData, setUserData] = useState([]);
  const [submitting, setSubmitting] = useState(false); // Loading state
  const antIcon = <LoadingOutlined style={{ fontSize: 38 }} spin />;


  const uniqueCategoryList = Array.from(
    new Map((categoryList || []).map((item) => [item.id, item])).values()
  );

  const hsCodeList = useSelector((state) => state.myProducts.hsCodeList || []);
  const uniqueProductRows = Array.from(
    new Map(
      (productList?.rows || [])
        .filter((option) => option.status === RFQStatus.APPROVED)
        .map((item) => [item?.categories?.id, item])
    ).values()
  );

  const setDataToForm = useCallback(
    (data) => {
      form.setFieldsValue({
        productName: data?.productName,
        productCategory: data?.categories.id,
        hsCode: data?.hscode.code ?? "",
        productSpecification: data?.description,
        sourceCountry: data?.sourceCountry,
        sourcePort: data?.sourcePort,
        destinationCountry: data?.destinationCountry,
        destinationPort: data?.destinationPort,
        containerType: data.containerType,
        noOfContainers: data.noOfContainers,
        netWeightPerContainer: data.netWeightPerContainer,
        shipmentMode: data?.shipmentMode,
        shipmentType: data?.shipmentType,
        cargoReadinessDate: moment(data?.cargoReadinessDate),
        currency: data?.currency,
        rateindication: data?.rateindication,
        excludeSendingCHA: data?.excludedUserIds || [],
      });

      setHsCodeId(data?.hsCodeId);
      setSelectedDestinationCountry(data?.destinationCountry);
      setSelectedSourceCountry(data?.sourceCountry);

      if (
        data?.productImages?.length < 4 &&
        !isEnquiryPublished(RFQFormStatus)
      ) {
        const images = data?.productImages;
        images.push({ src: "" });
        setFileList([...images]);
      } else if (isArrayNonEmpty(data?.productImages)) {
        setFileList([...data?.productImages]);
      }
    },
    [RFQFormStatus, form]
  );


  useEffect(() => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      MY_EXIM_API_RFQ.getRequestQuotationDetails({ id })
        .then((response) => {
          setDataToForm(response?.data?.data);
          setTargetedBusinessType([
            ...response?.data?.data?.targetedBusinessType,
          ]);
          setRFQFormStatus(response?.data?.data?.status);
          dispatch(fetchSuccess());
        })
        .catch((e) => {
          showAlert(e?.message);
          dispatch(fetchSuccess());
        });
    }
  }, [dispatch, id, setDataToForm]);

  useEffect(() => {
    if (targetedBusinessType?.[0] === BUSINESS_TYPE.CUSTOM_HOUSE_AGENT) {
      form.setFieldValue("shipmentMode", "sea");
      form.setFieldValue("shipmentType", "fcl");
    }
  }, [form, targetedBusinessType]);

  const onFinish = async (values, isDraftClick = false) => {
    setSubmitting(true); // Start loading
    
    try {
      let formData = isDraftClick ? form?.getFieldsValue() : values;
      const targetedBusinessType = [BUSINESS_TYPE.CUSTOM_HOUSE_AGENT ,BUSINESS_TYPE.CUSTOMHOUSEAGENTS_FREIGHTFORWARDER];

      let data = {
        productName: formData?.productName,
        description: formData?.productSpecification || "",
        categoryId: parseInt(formData?.productCategory),
        hsCodeId: hsCodeId,
        sourceCountry: formData?.sourceCountry || "",
        destinationCountry: formData?.destinationCountry || "",
        destinationPort: formData?.destinationPort || "",
        isDuplicate: hasCloneParam,
        businessTypeId: authUser?.businessTypeId,
        userId: authUser?.id,
        status: isDraftClick ? RFQStatus?.DRAFT : RFQStatus?.PUBLISHED,
        productImages: [...fileList.filter((file) => file?.src)],
        targetedBusinessType: targetedBusinessType,
        containerType: formData?.containerType,
        noOfContainers: formData?.noOfContainers,
        netWeightPerContainer: formData?.netWeightPerContainer,
        sourcePort: formData?.sourcePort,
        paymentTerms: formData?.paymentTerms,
        locationForDelivery: formData?.locationForDelivery,
        shipmentMode: formData?.shipmentMode,
        shipmentType: formData?.shipmentType,
        cargoWeight: formData?.cargoWeight,
        totalCubicMeter: formData?.totalCubicMeter,
        cargoReadinessDate: formData?.cargoReadinessDate,
        currency: formData?.currency,
        rateindication: formData?.rateindication,
        excludedUserIds: formData?.excludeSendingCHA || [],
      };

      await updatedDetailsToNetwork(data, isDraftClick);
    } catch (error) {
      console.error("Form submission error:", error);
      message.error("Failed to submit form. Please try again.");
    } finally {
      setSubmitting(false); // End loading regardless of success/failure
    }
  };


   const updatedDetailsToNetwork = async (data, isDraft = false) => {
    try {
      let url = isEdit
        ? `${BASE_API_CONFIG.baseURL}/enquiries/${id}`
        : `${BASE_API_CONFIG.baseURL}/enquiries`;
      await axiosInstance.post(url, data);
      message.success(
        `Your CHA quotation has been ${isDraft ? 'saved as draft' : 'submitted'} successfully`
      );
      history.goBack();
    } catch (err) {
      message.error(err.message);
      throw err; // Re-throw to be caught in onFinish
    }
  };

  useEffect(() => {
    const countryId = countries.find(
      (item) => item.country === selectedSourceCountry
    )?.id;

    const uniquePorts = Array.from(
      new Map(
        ports
          .filter((item) => item.countryId === countryId)
          .map((item) => [item.port, item])
      ).values()
    );
    setSourcePortsData(uniquePorts);
  }, [countries, ports, selectedSourceCountry]);

  const handleChangeSourceCountry = (value) => {
    setSelectedSourceCountry(value);
    form.resetFields(["sourcePort"]);
  };

  // useEffect(() => {
  //   const countryId = countries.find(
  //     (item) => item.country === selectedDestinationCountry
  //   )?.id;
  //   setDestinationPortsData(
  //     ports.filter((item) => item.countryId === countryId)
  //   );
  // }, [countries, ports, selectedDestinationCountry]);

useEffect(() => {
  if (selectedDestinationCountry && isArrayNonEmpty(countries) && isArrayNonEmpty(ports)) {
    // Clean and normalize the selected country name
    const cleanSelectedCountry = selectedDestinationCountry.trim().toUpperCase();
    
    // Filter ports by countryName (normalize both for comparison)
    const filteredPorts = ports.filter(item => {
      if (!item.countryName) return false;
      
      // Clean and normalize the port's country name
      const portCountry = item.countryName.trim().toUpperCase();
      return portCountry === cleanSelectedCountry;
    });
    
    setDestinationPortsData(filteredPorts);
    console.log("Filtered destination ports:", filteredPorts);
  } else {
    setDestinationPortsData([]);
  }
}, [selectedDestinationCountry, countries, ports]);


  const handleChangeDestinationCountry = (value) => {
    setSelectedDestinationCountry(value);
    form.resetFields(["destinationPort"]);
  };

  const validatePortSelection = async (_, value) => {
    const sourcePort = form.getFieldValue("sourcePort");
    if (value === sourcePort) {
      throw new Error("Source Port and Destination Port cannot be the same");
    }
  };

  const shipmentMode = Form.useWatch("shipmentMode", form);
  const shipmentType = Form.useWatch("shipmentType", form);

  const onUpload = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      if (updatedList.length < 4) {
        updatedList.push({ src: "" });
      }
      updatedList[data.index].originalName = data.originalName;
      return [...updatedList];
    });
  };
  const onRemove = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };

  const uploadComponent = (isDisabled) => {
    return (
      <div className="attachments">
        <div className="sub-header">Attachments</div>
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          {fileList?.length > 0 ? (
            fileList.map((file, index) => (
              <Upload
                key={index}
                isDisabled={isDisabled}
                index={index}
                src={file.src}
                id={index}
                label={
                  isValidString(file?.label) ? file?.label : getLabel(index)
                }
                originalName={file.originalName}
                onUpload={onUpload}
                onRemove={onRemove}
              />
            ))
          ) : (
            <div>No attachments added.</div>
          )}
        </div>
      </div>
    );
  };
  const handleChangeProductCategory = (value) => {
    form.resetFields(["hsCode"]);
    setHsCodeId(null);
    setFilteredHsCodeData(null);
    setHsCodeData(hsCodeList?.filter((item) => item?.categories?.id === value));
  };

  const validateTextArea = (_, value) => {
    if (value && value.length > 1000) {
      return Promise.reject(
        new Error("Product Requirements cannot exceed 1000 characters")
      );
    }
    return Promise.resolve();
  };

    const getUsersListAPICall = async () => {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/all/cha`
      );
      setUserData(response?.data?.data?.rows || []);
      dispatch(fetchSuccess());
    };
  
    useEffect(() => {
      dispatch(fetchStart());
      getUsersListAPICall();
    }, [dispatch]);
  

  const handleHSCodeSearch = (value) => {
    const trimmedValue = value.trim();
    const containsNumbers = /^\d+$/.test(trimmedValue.toLowerCase());

    setFilteredHsCodeData(() => {
      const filterFunction = (option) => {
        const codeString = option.code
          .toString()
          .replace(/\s+/g, "")
          .toLowerCase();
        const descriptionString = option.description
          .replace(/[\n\r"]/g, "")
          .toLowerCase();

        return containsNumbers
          ? codeString.includes(trimmedValue.toLowerCase())
          : descriptionString.includes(trimmedValue.toLowerCase());
      };

      return isValidElement(hsCodeData)
        ? hsCodeData.filter(filterFunction)
        : hsCodeList?.filter(filterFunction);
    });
  };

  const handleProductCategorySearch = (value) => {
    const trimmedValue = (value || "").trim().toLowerCase();

    if (!trimmedValue) {
      setFilteredProductCategoryData(null);
      return;
    }

    const filterFunction = (option) => {
      const categoryName = (option?.name || "").replace(/[\n\r\"]/g, "").toLowerCase();
      return categoryName.includes(trimmedValue);
    };

    const sourceList = isBuyer(authUser) ? uniqueCategoryList : categoryList;
    setFilteredProductCategoryData(sourceList.filter(filterFunction));
  };

  return (
    !loading && (
      <div style={{ position: 'relative' }}>
          {/* Loading Overlay */}
          {loading && (
            <div 
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
              }}
            >
            
               <Spin
            spinning={loading}
            indicator={antIcon}
            tip="Saving product..."
          ></Spin>
            </div>
          )}
      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <LeftOutlined
            className={"back-icon"}
            size="large"
            onClick={() => history.goBack()}
          />
          {isEnquiryPublished(RFQFormStatus) && !hasCloneParam
            ? "Create Enquiry to (CHA)Custom House Agent"
            : isEdit
            ? "Edit Enquiry to (CHA)Custom House Agent"
            : "Post Enquiry to (CHA)Custom House Agent"}
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          initialValues={{
            currency: "USD",
            includeFreightForwarders: false,
            sourceCountry: "India",
          }}
          className="gx-pt-4"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Product Name"
                name="productName"
                rules={[
                  { required: true, message: "Product name is required" },
                ]}
              >
                <Input
                  disabled={isEditDisabled}
                  placeholder="Enter service name"
                  size="large"
                  showCount
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent(
                  "Product Category",
                  `Products Categories displayed here is based on Approved Products under My Products.`
                )}
                name="productCategory"
                rules={[
                  {
                    required: true,
                    message: "Product Category is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  name={"productCategory"}
                  placeholder="Select Product Category"
                  disabled={isEditDisabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={handleChangeProductCategory}
                  onSearch={handleProductCategorySearch}
                  dropdownStyle={{ maxHeight: "200px", overflowX: "hidden" }}
                  filterOption={false}
                >
                  {(isArrayNonEmpty(filteredProductCategoryData)
                    ? filteredProductCategoryData
                    : (isBuyer(authUser) ? uniqueCategoryList : categoryList))
                    ?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.name.charAt(0).toUpperCase() +
                          option.name.slice(1).toLowerCase()}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                disabled={isEditDisabled}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent(
                  "HS Code / Item Description",
                  "Select appropriate HS Code to get the Quotation from Right Partiers."
                )}
                help={labelComponent(
                  <span style={{ color: "#1677ff" }}>
                    Note: We are not responsible for any country-specific
                    restrictions for the selected product; please ensure you
                    review Source and Destination country’s regulations before
                    making an inquiry
                  </span>
                )}
                name="hsCode"
                rules={[
                  {
                    required: true,
                    message: "HS code is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  name="hsCode"
                  placeholder="Select HS code / Item Description"
                  filterOption={false}
                  dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabled={isEditDisabled}
                  onChange={(value) => {
                    setHsCodeId(value);
                  }}
                  onSearch={handleHSCodeSearch}
                >
                  {isValidElement(filteredHsCodeData)
                    ? filteredHsCodeData?.map((option) => (
                        <Option key={option.id} value={option.id}>
                          <div style={{ whiteSpace: "normal" }}>
                            {option.code} -{" "}
                            {option.description.replace(/[\n\r"]/g, "")}
                          </div>
                        </Option>
                      ))
                    : hsCodeData?.map((option) => (
                        <Option key={option.id} value={option.id}>
                          <div style={{ whiteSpace: "normal" }}>
                            {option.code} -{" "}
                            {option.description.replace(/[\n\r"]/g, "")}
                          </div>
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent(
                  "Loading Country",
                  "Currently we are allowing Loading country as India only"
                )}
                name="sourceCountry"
                rules={[
                  { required: true, message: "Loading country is required" },
                ]}
              >
                <Select
                  defaultValue={
                    isBuyer(authUser) ||
                    isExporter(authUser) ||
                    isManufacturerCumExporter(authUser)
                      ? "India"
                      : null
                  }
                  disabled={
                    isEditDisabled ||
                    isBuyer(authUser) ||
                    isExporter(authUser) ||
                    isManufacturerCumExporter(authUser)
                  }
                  showSearch
                  size="large"
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={handleChangeSourceCountry}
                  value={selectedSourceCountry}
                  placeholder="Select Loading Country"
                >
                  {countries?.map(
                    (option) =>
                      option.country !== "" && (
                        <Option key={option.country} value={option.country}>
                          {option.country}
                        </Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Loading Port"
                name="sourcePort"
                rules={[
                  { required: true, message: "Loading port is required" },
                ]}
              >
                <Select
                  showSearch
                  virtual={false}
                  size="large"
                  placeholder="Select Loading Port"
                  disabled={!selectedSourceCountry}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {isValidElement(sourcePortsData)
                    ? sourcePortsData?.map((option) => (
                        <Option key={option.port} value={option.port}>
                          {`${option.port} (${option.code})`}
                        </Option>
                      ))
                    : ports?.map((option) => (
                        <Option key={option.port} value={option.port}>
                          {`${option.port} (${option.code})`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Destination Country"
                name="destinationCountry"
                rules={[
                  {
                    required: true,
                    message: "Destination country is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  placeholder="Select Destination Country"
                  onChange={handleChangeDestinationCountry}
                  value={selectedDestinationCountry}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {countries?.map((option) => (
                    <Option key={option.country} value={option.country}>
                      {option.country}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Destination Port"
                name="destinationPort"
                rules={[
                  { required: true, message: "Destination port is required" },
                  { validator: validatePortSelection },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  placeholder="Select Destination Port"
                  disabled={!selectedDestinationCountry}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                    {destinationPortsData.map((option) => (
    <Option key={option.port} value={option.port}>
      {`${option.port} (${option.code})`}
    </Option>
  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Shipment Mode"
                name="shipmentMode"
                rules={[
                  { required: true, message: "Shipment mode is required" },
                ]}
              >
                <Radio.Group
                  options={shipmentModes}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
            </Col>

            {shipmentMode === "sea" && (
              <Col span={24}>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label="Shipment Type"
                  name="shipmentType"
                  rules={[
                    { required: true, message: "Shipment type is required" },
                  ]}
                >
                  <Radio.Group
                    options={shipmentTypes}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Form.Item>
              </Col>
            )}

            {(shipmentMode === "air" || shipmentType === "lcl") && (
              <>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Cargo Weight (In Kilograms)"
                    name="cargoWeight"
                    rules={[
                      { required: true, message: "Cargo weight is required" },
                    ]}
                  >
                    <Input
                      disabled={isEditDisabled}
                      placeholder="Cargo Weight"
                      size="large"
                      type="number"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Total Cubic Meters (m^3)"
                    name="totalCubicMeter"
                    rules={[{ required: true, message: "Volume is required" }]}
                  >
                    <Input
                      disabled={isEditDisabled}
                      placeholder="Total Volume"
                      size="large"
                      type="number"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {shipmentMode === "sea" && shipmentType === "fcl" && (
              <>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Container Type"
                    name="containerType"
                    rules={[
                      { required: true, message: "Container type is required" },
                    ]}
                  >
                    <Select
                      showSearch
                      size="large"
                      placeholder="Select Container type"
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      <Option value="20drystandard">20' Dry Standard</Option>
                      <Option value="40drystandard">40' Dry Standard</Option>
                      <Option value="40dryhighcube">40' Dry High Cube</Option>
                      <Option value="45dryhighcube">45' Dry High Cube</Option>
                      <Option value="20reefer">20' Reefer</Option>
                      <Option value="40reeferhighcube">
                        40' Reefer High Cube
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="No. of Containers"
                    name="noOfContainers"
                    rules={[
                      {
                        required: true,
                        message: "Number of containers is required",
                      },
                    ]}
                  >
                    <InputNumber min={1} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Net Weight Per Container (Kilograms)"
                    name="netWeightPerContainer"
                    rules={[
                      { required: true, message: "Net weight is required" },
                    ]}
                  >
                    <InputNumber min={0} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>

          <Row>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Cargo Readiness Date"
                name="cargoReadinessDate"
                rules={[
                  {
                    required: true,
                    message: "Cargo readiness date is required",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabledDate={(currentDate) => {
                    const cargoReadinessDate =
                      form.getFieldValue("cargoReadinessDate");
                    return (
                      currentDate && currentDate.isBefore(cargoReadinessDate)
                    );
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                disabled={isEditDisabled}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Requirements"
                name="productSpecification"
                rules={[
                  { validator: validateTextArea },
                  { required: true, message: "Requirements are required" },
                ]}
              >
                <TextArea
                  rows={10}
                  placeholder="Provide your shipping requirements like, Cargo Readiness date / Container Pickup date and any indicative Price..etc."
                  showCount
                  maxLength={1000}
                  disabled={isEditDisabled}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="gx-pt-5">
            <Col span={24}>
              <Form.Item className="gx-text-center">
                <div
                  className="gx-mr-3"
                  style={{
                    justifyContent: isMobile ? "center" : "end",
                    display: "flex",
                    flex: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    type="secondary"
                    size="large"
                    style={{ width: 150 }}
                    onClick={() => history.goBack()}
                  >
                    Cancel
                  </Button>
                  {!isEditDisabled &&
                    RFQFormStatus !== RFQStatus.PENDING_APPROVAL && (
                      <Button
                        type="secondary"
                        size="large"
                        style={{ width: 150 }}
                        onClick={() => onFinish(form, true)}
                      >
                        Save as draft
                      </Button>
                    )}
                  {!isEditDisabled && (
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      style={{ width: 150 }}
                      loading={submitting}
                      disabled={submitting}
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      </div>
    )
  );
};

export default PostChaQuotationsDetails;
